import { AccessSource } from '@prisma/client';
import { useQuery } from '@tanstack/react-query';

import { AgsIdentity } from '@app/integ-ags-interface';
import { Axios } from '@app/web-components';

const ACCESS_APPROVERS_ALL_QUERY_KEY = 'ACCESS_APPROVERS_ALL_QUERY_KEY';

const accessApproversKeys = {
  all: [ACCESS_APPROVERS_ALL_QUERY_KEY] as const,
  lists: () => [...accessApproversKeys.all, 'list'] as const,
  list: (filters: object) => [...accessApproversKeys.lists(), filters] as const,
};

export const useFindAgsAccessApprovers = (accessSource: AccessSource, externalId: string) => {
  const axios = Axios.useAxiosApi();

  if (accessSource === AccessSource.IEM) {
    throw new Error('IEM accesses are not supported.');
  }

  const type = accessSource === AccessSource.AGS_ROLE ? 'roles' : 'entitlements';

  return useQuery<AgsIdentity[]>({
    queryKey: accessApproversKeys.list({ accessSource, externalId }),
    queryFn: async () => {
      const { data } = await axios.get(`/ags/${type}/${externalId}/approvers`);
      return data;
    },
  });
};
